import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ACCOUNT, MAIN, PROFILE } from '../constants/routes.const';
import { UserService } from '../services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class BankGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private toastCtrl: ToastController,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const user = this.userService.currentUser.value;
    if (!user) return false;
    if (user.hasBankAccount) {
      return true;
    }

    this.showToast('Você precisa cadastrar uma conta bancária para anúnciar.');

    if (!user?.kyc?.start_kyc) {
      this.showToast('Você precisa realizar a prova de vida da pagarme.');
    }

    const urlString = ['', MAIN, PROFILE.BASE, ACCOUNT.BASE].join('/');
    return this.router.parseUrl(urlString);
  }

  async showToast(message: string) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color: 'primary',
      position: 'bottom',
      cssClass: 'tabs-bottom',
    });

    toast.present();
  }
}
